import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';

@Pipe({
	name: 'filterEmployeeBySkill'
})
export class FilterEmployeeBySkillPipe implements PipeTransform {
	transform(employees: Employee[], filter: string | string[]): Employee[] {
		if (
			employees === null ||
			!employees ||
			(Array.isArray(employees) && employees.length === 0) ||
			filter === null ||
			filter === '' ||
			(Array.isArray(filter) && filter.length === 0)
		) {
			return employees;
		}

		if (!Array.isArray(filter)) {
			filter = [filter];
		}

		return employees.filter((employee) => {
			const careSkills = employee.careSkills || [];

			// Vérifie si l'une des compétences correspond à un des filtres
			for (const careSkill of careSkills) {
				for (const comp of filter) {
					if (careSkill.name.toLowerCase().includes(comp.toLowerCase())) {
						return true;
					}
				}
			}

			return false;
		});
	}
}
